<script setup lang="ts">
import { ref } from 'vue'
import Toast from './Toast.vue'

interface ToastItem {
  id: string
  message: string
  type: 'info' | 'warning' | 'error'
  timeout?: number
}

const toasts = ref<ToastItem[]>([])

const addToast = (
  message: string,
  type: 'info' | 'warning' | 'error' = 'info',
  timeout: number = 5000 // default 5s
) => {
  const id = Date.now().toString()
  const toast: ToastItem = { id, message, type, timeout }
  toasts.value.push(toast)

  // ⏳ Auto-remove if timeout > 0
  if (timeout > 0) {
    setTimeout(() => removeToast(id), timeout)
  }
}

const removeToast = (id: string) => {
  toasts.value = toasts.value.filter(toast => toast.id !== id)
}

defineExpose({
  addToast
})
</script>

<template>
  <div class="fixed top-4 right-4 z-[1000] space-y-2">
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :id="toast.id"
      :message="toast.message"
      :type="toast.type"
      @close="removeToast"
    />
  </div>
</template>
